export class BaseError extends Error {
    constructor() {
        super();
        Error.apply(this, arguments);
    }
}
